import { Sheet } from "@heroui-pro/react/sheet";
import type { ReactNode } from "react";

type AccountCreateDrawerProps = {
  open: boolean;
  children: ReactNode;
  className?: string;
  testId?: string;
};

export const AccountCreateDrawer = ({
  open,
  children,
  className,
  testId,
}: AccountCreateDrawerProps) => (
  <Sheet isOpen={open} placement="bottom" isDismissable={false}>
    <Sheet.Backdrop variant="blur">
      <Sheet.Content
        data-testid={testId}
        className={`mx-auto max-h-[90vh] max-w-[420px] ${className ?? ""}`}
      >
        <Sheet.Dialog className="rounded-t-3xl" style={{ background: "hsl(var(--brand-bg))" }}>
          <Sheet.Handle />
          <Sheet.Body className="flex flex-col gap-3 px-5 pb-6 pt-2">{children}</Sheet.Body>
        </Sheet.Dialog>
      </Sheet.Content>
    </Sheet.Backdrop>
  </Sheet>
);

export default AccountCreateDrawer;
